import { request } from '@/api/client'

/** A partner courier company we push status updates to (gateway ext/partnerHooks.ts); the URL comes back masked only. */
export interface PartnerHook {
  id: number
  clientId: number
  clientName: string
  name: string
  urlMasked: string
  enabled: boolean
  secretAt: number
  createdAt: number
  createdBy: string
  lastSuccessAt: number | null
  lastFailureAt: number | null
  lastError: string | null
  today?: number
  failedToday?: number
}
export interface PartnerDelivery {
  id: number
  partnerId: number
  awb: string
  event: string
  status: string
  reason: string
  state: 'pending' | 'sent' | 'failed' | 'gave_up'
  attempts: number
  nextAt: number | null
  statusCode: number | null
  latencyMs: number | null
  error: string | null
  createdAt: number
  sentAt: number | null
}
export interface PartnerStats { total: number; sent: number; failed: number; pending: number }

const base = '/ext/partner-hooks'
export const partnerHooksService = {
  list: async (signal?: AbortSignal) => (await request<PartnerHook[]>(base, { signal })).data,
  detail: async (id: number, signal?: AbortSignal) => (await request<{ partner: PartnerHook; today: PartnerStats; week: PartnerStats; deliveries: PartnerDelivery[] }>(`${base}/${id}`, { signal })).data,
  create: async (body: { clientId: number; clientName: string; name: string; url: string }) => (await request<{ partner: PartnerHook; secret: string }>(base, { method: 'POST', body })).data,
  update: async (id: number, body: { name?: string; url?: string; enabled?: boolean }) => (await request<PartnerHook>(`${base}/${id}`, { method: 'PUT', body })).data,
  rotate: async (id: number) => (await request<{ secret: string; secretAt: number }>(`${base}/${id}/rotate`, { method: 'POST', body: {} })).data,
  test: async (id: number) => (await request<PartnerDelivery>(`${base}/${id}/test`, { method: 'POST', body: {} })).data,
  resend: async (deliveryId: number) => (await request<PartnerDelivery>(`${base}/deliveries/${deliveryId}/resend`, { method: 'POST', body: {} })).data,
  remove: async (id: number) => (await request<null>(`${base}/${id}`, { method: 'DELETE' })).data,
}

/** طلبات Webhook: what partner companies asked for from their portal settings (gateway ext/webhookRequests.ts). */
export interface WebhookRequestRow {
  id: number
  clientId: number
  accountName: string
  companyName: string
  url: string
  requestedAt: number
  state: 'pending' | 'approved' | 'rejected' | 'withdrawn'
  reason: string | null
  decidedBy: string | null
  decidedAt: number | null
  partnerId: number | null
  active: boolean
  probe: { ok: boolean; statusCode: number | null; latencyMs: number; error: string | null; at: number } | null
}
const reqBase = '/ext/partner-hook-requests'
export const webhookRequestsService = {
  list: async (signal?: AbortSignal) => (await request<{ pending: number; requests: WebhookRequestRow[] }>(reqBase, { signal })).data,
  count: async (signal?: AbortSignal) => (await request<{ pending: number }>(`${reqBase}/count`, { signal })).data.pending,
  probe: async (id: number) => (await request<NonNullable<WebhookRequestRow['probe']>>(`${reqBase}/${id}/probe`, { method: 'POST', body: {} })).data,
  approve: async (id: number) => (await request<WebhookRequestRow>(`${reqBase}/${id}/approve`, { method: 'POST', body: {} })).data,
  reject: async (id: number, reason: string) => (await request<WebhookRequestRow>(`${reqBase}/${id}/reject`, { method: 'POST', body: { reason } })).data,
}
